const config = {
  title: "Sistema Editoriale Visit Romagna",
  titleHtml: "",
  logo: require("../assets/img/positivo-nero.png"),
  logoPositivo: require("../assets/img/logo-home.png"),
};

export default config;